import React from 'react';
import { HumioIntegrationContextType } from './HumioIntegrationProvider.types';

/**
 * React context for Humio integration
 */
export const HumioIntegrationContext = React.createContext<
  HumioIntegrationContextType | undefined
>(undefined);
